<template>
    <section class="py-12 mx-auto w-full bg-white lg:py-12 xl:px-16 lg:px-4 md-max:pt-6">
        <div class="px-4 mx-auto sm:px-6 lg:px-2">
            <div class="flex flex-col gap-y-6 gap-x-10 items-center lg:flex-row lg:items-start xl:gap-x-20">
                <!-- Left Column -->
                <div class="w-full text-center lg:basis-80 lg:text-left">
                    <h4 :class="newStyle ? 'md-max:text-2xl' : ''"
                        class="mb-8 text-xl font-bold leading-tight text-black xl:text-2xl font-ww-bold md:mb-12"
                        v-html="title">
                    </h4>

                    <div class="flex flex-wrap gap-4 gap-y-6 justify-center items-center lg:justify-center lg:gap-x-6">
                        <div v-for="(logo, index) in logos" :key="index" class="">
                            <nuxt-img :src="logo.image" :alt="logo.alt || 'Partner logo'" class="object-contain w-full"
                                loading="lazy" sizes="xs:100px sm:100px md:100px lg:100px xl:100px 2xl:100px" />
                        </div>
                    </div>
                </div>

                <!-- Right Column -->
                <div class="w-full lg:w-[605px]">
                    <nuxt-img :src="rightImageDesktop" alt="Featured Article Desktop" class="hidden w-full lg:block"
                        width="605" height="494" loading="lazy" format="webp"
                        sizes="xs:300px sm:400px md:600px lg:605px xl:605px 2xl:605px" />

                    <nuxt-img :src="rightImageMobile" alt="Featured Article Mobile"
                        class="w-full lg:hidden max-w-[700px] mx-auto" width="699" height="1851" loading="lazy"
                        format="webp" sizes="xs:300px sm:400px md:600px lg:605px xl:605px 2xl:605px" />

                </div>
            </div>
        </div>
    </section>
</template>

<script setup>

const props = defineProps({
    newStyle: { type: Boolean, default: false },
    title: {
        type: String,
        default: 'Everyone Is Talking About Lifeboost Coffee Including:'
    },
    logos: {
        type: Array,
        default: () => [
            { image: '/assets/images/bogo-logo-1.png', alt: 'CBS8' },
            { image: '/assets/images/bogo-logo-2.png', alt: 'The Buffalo News' },
            { image: '/assets/images/bogo-logo-3.png', alt: 'finanzen.net' },
            { image: '/assets/images/bogo-logo-4.png', alt: 'Green Living' },
            { image: '/assets/images/bogo-logo-5.png', alt: '69 News' },
            { image: '/assets/images/bogo-logo-6.png', alt: '96' },
            { image: '/assets/images/bogo-logo-7.png', alt: '6' },
            { image: '/assets/images/bogo-logo-8.png', alt: '69 News TV' },
            { image: '/assets/images/bogo-logo-9.png', alt: 'KXAN' },
            { image: '/assets/images/bogo-logo-10.png', alt: 'Spoke' }
        ],
    },
    articleImages: {
        type: Array,
        default: () => [
            '/assets/images/bogo-r-1.png',
            '/assets/images/bogo-r-2.png',
            '/assets/images/bogo-r-3.png',
            '/assets/images/bogo-r-4.png',
            '/assets/images/bogo-r-5.png',
            '/assets/images/bogo-r-6.png'
        ]
    },
    rightImageDesktop: {
        type: String,
        default: '/assets/images/Talking-lifeboost-destkop.png'
    },
    rightImageMobile: {
        type: String,
        default: '/assets/images/Talking-lifeboost-mobile.png'
    }
});

defineBuilderComponent({
    friendlyName: 'Logo List With Image',
    inputs: [
        {
            name: "newStyle",
            type: "boolean",
            defaultValue: false,
            friendlyName: "New Style"
        },
        {
            name: 'title',
            type: 'text',
            defaultValue: 'Everyone Is Talking About Lifeboost Coffee Including:',
            friendlyName: 'Section Title'
        },
        {
            name: 'rightImageDesktop',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
            defaultValue: '/assets/images/Talking-lifeboost-destkop.png',
            friendlyName: 'Right Side Image (Desktop)'
        },
        {
            name: 'rightImageMobile',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
            defaultValue: '/assets/images/Talking-lifeboost-mobile.png',
            friendlyName: 'Right Side Image (Mobile)'
        },
        {
            name: 'logos',
            type: 'list',
            defaultValue: [
                { image: '/assets/images/bogo-logo-1.png', alt: 'CBS8' },
                { image: '/assets/images/bogo-logo-2.png', alt: 'The Buffalo News' },
                { image: '/assets/images/bogo-logo-3.png', alt: 'finanzen.net' },
                { image: '/assets/images/bogo-logo-4.png', alt: 'Green Living' },
                { image: '/assets/images/bogo-logo-5.png', alt: '69 News' },
                { image: '/assets/images/bogo-logo-6.png', alt: '96' },
                { image: '/assets/images/bogo-logo-7.png', alt: '6' },
                { image: '/assets/images/bogo-logo-8.png', alt: '69 News TV' },
                { image: '/assets/images/bogo-logo-9.png', alt: 'KXAN' },
                { image: '/assets/images/bogo-logo-10.png', alt: 'Spoke' }
            ],
            subFields: [
                {
                    name: 'image',
                    type: 'file',
                    allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
                    required: true
                },
                {
                    name: 'alt',
                    type: 'text',
                    defaultValue: 'Logo'
                }
            ]
        },
    ],
});
</script>